<template>
<div class="navigation">
<b-navbar toggleable type="dark" variant="care">
  <a v-if="path.length !== 0" class="back-button" @click="goBack">
    <i class="fa fa-angle-left fa-2x"></i>
  </a>
  <b-navbar-brand href="#">
     <router-link to="/">
     <img src="../assets/RSKlogo.svg" class="logo"/>
     </router-link>
  </b-navbar-brand>
  <router-link to="/">
  <h1 class="d-inline logo-text">{{isTestEnv ? 'Test' : 'Stöd vid läkemedelshantering'}}</h1>
  </router-link>
  <!-- Right aligned nav items -->
  <b-nav class="ml-auto hidden-sm-down" v-if="!isMobile">
    <b-nav-item v-if="!user.isAuthenticated" to="/logga-in"><i class="fa fa-2x fa-user-o"></i></b-nav-item>
    <b-nav-item v-if="user.isAuthenticated" @click="logout"><span class="username">{{ user.name }}</span>&nbsp; <i class="fa fa-2x fa-user"></i></b-nav-item>
  </b-nav>
</b-navbar>
<!-- navbar-1.vue -->
</div>
</template>

<script>
import auth from '../services/auth'
import { isContainerApp } from '../services/helpers'

export default {
  name: 'Navigation',
  data () {
    return {
      path: [],
      routeParent: {
        'KrossningsSilFormat': 'EditeraKrossningsPost',
        'EditeraKrossningsPost': 'Krossning',
        'RedigeraKrossningsAnvisninar': 'Krossning',
        'KrossningsInstruktioner': 'Krossning',
        'Krossning': 'Start',
        'Ogondroppar': 'Start',
        'RedigeraOgonAnvisninar': 'Ogondroppar',
        'SpädningsInstruktioner': 'Spädning',
        'Spädning': 'Start',
        'Nedsatt njurfunktion instruktioner': 'Nedsatt njurfunktion',
        'Nedsatt njurfunktion': 'Start'
      }
    }
  },

  computed: {
    user () {
      return this.$store.state.user
    },
    isProductionEnv () {
      return process.env.NODE_ENV === 'production'
    },
    isTestEnv () {
      const url = window.location.href
      return url.includes('test')
    },
    isMobile () {
      return isContainerApp()
    }
  },
  methods: {
    logout () {
      auth.logout(this.$store)
      // We need to logout backend. Backend then return us to start page
      window.location = process.env.BASE_URL + 'logout'
    },
    goBack () {
      const target = this.routeParent[this.$router.currentRoute.name] || 'Start'
      this.$router.push({ name: target })
    }
  },
  watch: {
    '$route': {
      handler () {
        this.path = this.$router.history.current.path.split('/').filter(s => s.length !== 0)
      },
      immediate: true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.navigation {
   .navbar {
     height:80px;
      h5 {
         color: #fff;
         margin-left: 10px;
      }
      .logo-text {
        @include media-down($md) {
          font-size: 18px;
        }
        @include media-down($sm) {
          font-size: 18px;
        }
        @include media-down($xs) {
          font-size: 15px;
        }
        @include media-down($xxs) {
          font-size: 13px;
        }
        @include media-down($xxxs) {
          display: none !important;
        }
        color:#fff;
      }
      img.logo {
         width: 50px;
      }
      justify-content: unset;
   }
   .bg-care {
      background-color: $orange;
      a {
         color: #fff
      }
   }
   .hidden-sm-down{
    @media (max-width: 540px) {
      display: none;
    }
  }
}
h1, h2 {
  font-weight: normal;
}

.back-button
{
  cursor: pointer;
  background-color: $orange;
  border-color: $orange;
  box-shadow: $orange;
  margin-right: 20px;
    i.fa {
      color: #fff;
    }
}

.btn-secondary:not([disabled]):not(.disabled):active, .btn-secondary:not([disabled]):not(.disabled).active, .show > .btn-secondary.dropdown-toggle {
  background-color: $orange;
  border-color: $orange;
  box-shadow: 0 0 0 0.2rem $orange;
}

</style>
